<template>
    <div>
        <div class="availability-bookingtype">
            <rental-type-toggle
                v-model="rental"
                :disabled="states.loading || !space.enabled || !space.approved"
                :space="space"
            />
        </div>
        <booking-alerts
            v-if="states.errors.length"
            :messages="states.errors"
        />
        <div class="availability-inputs">
            <arrival-input
                :disabled="states.loading || !space.enabled || !space.approved"
                :time-config="trueStartTimeConfig(onlyBookEarlierForTimeConfig, canPastbook)"
                :date-config="trueStartDateConfig(pastBookLimit, onlyBookEarlierForDateConfig, canPastbook)"
                :rental="rental"
                :date.sync="start_date"
                :time.sync="start_time"
            />
            <departure-input
                v-if="rental === 'short'"
                :disabled="states.loading || !space.enabled || !space.approved"
                :date-config="endDateConfig"
                :time-config="endTimeConfig"
                :rental="rental"
                :date.sync="end_date"
                :time.sync="end_time"
            />
            <checker-detail-row v-if="isSeason || space.follow_up || !space.approved ">
                <div slot="left">Duration</div>
                <div slot="right">
                    <season-ticket-duration-select
                        v-model="interval_count"
                        :space="space"
                        :disabled="states.loading || !space.enabled"
                    />
                </div>
            </checker-detail-row>
        </div>
        <availability-details
            v-if="(space.enabled && !space.follow_up && space.approved)"
            :rental="rental"
            :quote="quote"
            :space="space"
        />
        <space-pricing
            v-else
            :space="space"
        />
    </div>
</template>

<script>
    import BookingAlerts from '../booking-form/Alerts.vue';
    import SaneDates from '../../mixins/SaneDates.vue';
    import SpaceValidation from '../../mixins/SpaceValidation.vue';
    import LongTermBookingTotalLabel from '../LongTermBookingTotalLabel';
    import CheckerDetailRow from './CheckerDetailRow';
    import SpacePricing from './SpacePricing';
    import RentalTypeToggle from './RentalTypeToggle';
    import ArrivalInput from './ArrivalInput';
    import DepartureInput from './DepartureInput';
    import AvailabilityDetails from './AvailabilityDetails';
    import SeasonTicketDurationSelect from './season-tickets/SeasonTicketDurationSelect';
    import { mapGetters } from 'vuex';
    import { mapReducers } from '../../../modules/reducer';

    export default {
        name: 'default-checker',

        components: {
            SeasonTicketDurationSelect,
            AvailabilityDetails,
            DepartureInput,
            ArrivalInput,
            RentalTypeToggle,
            SpacePricing,
            CheckerDetailRow,
            LongTermBookingTotalLabel,
            BookingAlerts,
        },

        mixins: [SaneDates, SpaceValidation],

        props: {
            states: {
                type: Object,
                default() {
                    return {};
                },
            },

            space: {
                type: Object,
                default() {
                    return {};
                },
            },
        },

        computed: {
            ...mapReducers('$store.state.booking.reservation_details', 'booking/updateReservationData', [
                'bookings',
                'interval_count',
                'rental',
            ]),

            ...mapGetters('booking', [
                'isSeason',
            ]),

            ...['start_date', 'start_time', 'end_date', 'end_time', 'quote'].reduce((computed, prop) => ({
                ...computed,
                [prop]: {
                    get() {
                        return this.$store.state.booking.reservation_details.bookings[0][prop];
                    },
                    set(value) {
                        this.$store.commit('booking/updateBookingData', {
                            ...this.$store.state.booking.reservation_details.bookings[0],
                            [prop]: value,
                        });
                    },
                },
            }), {}),

            /**
             * Does the space allow prebooking
             *
             * @returns {Boolean}
             */
            canPrebook() {
                return this.space.allow_phone_prebookings;
            },

            /**
             * checks how long ago a past booking can be
             *
             * @returns {number}
             */
            pastBookLimit() {
                return this.space.post_pay.max_hours_back;
            },

            /**
             * Does the space only allow past booking for date config
             *
             * @returns {Boolean}
             */
            onlyBookEarlierForDateConfig() {
                return this.canPastbook && !this.canPrebook;
            },

            /**
             * Does the space only allow past booking for time config
             *
             * @returns {Boolean}
             */
            onlyBookEarlierForTimeConfig() {
                if (this.canPrebook) {
                    return this.onlyBookEarlierForDateConfig;
                }

                return false;
            },

            /**
             * Does the space allow past booking
             *
             * @returns {Boolean}
             */
            canPastbook() {
                return this.space.post_pay.allow;
            },
        },
    };
</script>

<style lang="less">
    @import "~assets/less/variables";
    @import "~bootstrap/less/mixins/clearfix";
    @import "~bootstrap/less/mixins/grid";

    .availability-inputs {
        h5 {
            text-transform: none;
            letter-spacing: inherit;
            font-size: inherit;
            color: inherit;
            font-weight: bold;
            font-family: inherit;
            margin-bottom: 10px;
            margin-top: 0;
        }
        .checker-detail-left {
            h5 {
                margin: 0;
            }
        }
        .form-groups {
            .make-row(10px);
            .clearfix;
            .form-group {
                .make-xs-column(6, 5px);
            }
        }
    }
</style>
